import { useEffect } from "react";

export default function DeviceRedirect() {
    useEffect(() => {
        const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
        const hostname = window.location.hostname;

        const isMobileDomain = hostname.startsWith("m.");

        if (isMobile && !isMobileDomain) {
            window.location.href = `https://m.mccarty.cam`;
        }

        if (!isMobile && isMobileDomain) {
            window.location.href = `https://mccarty.cam`;
        }
    }, []);

    return null;
}